import { createEntityCommand } from '../../../shared/base';
import { GetAvailableVendorCompaniesParam } from '@resident-select/domain/vendor-company';

export const GetAvailableVendorCompaniesCommand =
  createEntityCommand<GetAvailableVendorCompaniesParam>('GetAvailableVendorCompaniesCommand');
